import { getKeyForValueFromMap } from '../get-key-for-value-from-map/get-key-for-value-from-map'

export const driveTypeValueMappings = new Map([
  ['four-wheel-drive', 'four-wheel drive'],
  ['rwd', 'rear-wheel drive'],
  ['fwd', 'front-wheel drive'],
])

export function convertFilterValueToUrlSegment(
  filterKey: string,
  filterValue: string,
) {
  const normalisedValue = filterValue.toLowerCase().replace(/ /g, '-')
  switch (filterKey) {
    case 'bodyType': {
      return `${normalisedValue}-body-type`
    }
    case 'colour': {
      return `${normalisedValue}-colour`
    }
    case 'doors': {
      return `${normalisedValue}-doors`
    }
    case 'driveType': {
      return `${getKeyForValueFromMap(
        driveTypeValueMappings,
        filterValue,
      )}-drive-type`
    }
    case 'fuelType': {
      return `${normalisedValue}-fuel-type`
    }
    case 'gearbox': {
      return `${normalisedValue}-gearbox`
    }
    case 'seats': {
      return `${normalisedValue}-seats`
    }
    case 'vehicleYear': {
      return `${normalisedValue}-year`
    }
    case 'rangeInMiles': {
      return `${normalisedValue}-range-in-miles`
    }
    case 'monthlyPrice': {
      return `${normalisedValue}-per-month`
    }
    case 'totalPrice': {
      return `${normalisedValue}-price`
    }
    default: {
      return normalisedValue
    }
  }
}
